import {
  ADD_DISPATCH,
  GET_DISPATCHES,
  DISPATCH_HISTORY,
  COMPANY_DISPATCHES_HIS,
  DISPATCH_EDIT,
  CLOTH_RETURN_EDIT,
} from "../Action/dispatch";
const initialState = {
  disptches: [],
  dispatchHistory: [],
  company_disptches_his: [],
  reload: true,
};

function dispatches(state = initialState, action) {
  switch (action.type) {
    case ADD_DISPATCH: {
      return {
        ...state,
        disptches: [action.payload, ...state.disptches],
        reload: !state.reload,
      };
    }
    case DISPATCH_HISTORY: {
      return {
        ...state,
        dispatchHistory: action.payload,
      };
    }
    case GET_DISPATCHES: {
      return { ...state, disptches: action.payload };
    }
    case DISPATCH_EDIT: {
      console.log(action.payload);
      let UpdatedDispatch = state.dispatchHistory.map((item) =>
        item.dispatch_id === action.payload.dispatch_id ? action.payload : item
      );
      return {
        ...state,
        dispatchHistory: UpdatedDispatch,
      };
    }
    case CLOTH_RETURN_EDIT: {
      console.log(action.payload);
      let UpdatedDispatch = state.dispatchHistory.map((item) =>
        item.dispatch_id_cloth_return ===
        action.payload.dispatch_id_cloth_return
          ? action.payload
          : item
      );
      return {
        ...state,
        dispatchHistory: UpdatedDispatch,
      };
    }
    case COMPANY_DISPATCHES_HIS: {
      const payload = action.payload;
      return {
        ...state,
        company_disptches_his: Array.isArray(payload)
          ? payload
          : payload?.result || [],
      };
    }
    default:
      return state;
  }
}

export default dispatches;
